import { ToolsContainerProps } from './../../../../../../components/Container'

export const toolsList: ToolsContainerProps[] = []
